import React, { useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * Second step of any destructive action. Every delete in the app routes
 * through this, so the wording and the weight of the decision stay identical
 * everywhere.
 *
 * Pass `name` to have the record spelled back to the user — confirming a
 * deletion you can't see the name of is how the wrong row gets removed.
 */
const ConfirmDialog = ({
  open,
  title = "Ростдан ҳам ўчирмоқчимисиз?",
  name,
  message = "Ушбу амални қайтариб бўлмайди.",
  confirmLabel = "Ўчириш",
  cancelLabel = "Бекор қилиш",
  busyLabel = "Ўчирилмоқда...",
  busy = false,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape" && !busy) onCancel?.();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, busy, onCancel]);

  if (!open) return null;

  return (
    <div
      className="ms-modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !busy) onCancel?.();
      }}
    >
      <div className="ms-modal ms-modal--confirm" role="alertdialog" aria-modal="true">
        <div className="ms-confirm-icon">
          <Icon icon="tabler:trash" />
        </div>

        <h2>{title}</h2>

        {name && <p className="ms-confirm-name">{name}</p>}

        <p className="ms-confirm-note">{message}</p>

        <div className="ms-confirm-actions">
          <button
            type="button"
            className="ms-btn ms-btn--ghost"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelLabel}
          </button>

          <button
            type="button"
            className="ms-btn ms-btn--danger"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? busyLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
